(function () {
    var ticker = document.querySelector('.horizontal-ticker');
    if (!ticker) return;
    
    function onScroll() {
    if (window.scrollY > 0) {
    ticker.classList.add('spn-ticker-fixed');
    } else {
    ticker.classList.remove('spn-ticker-fixed');
    }
    }
    
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    })();
    
    (function () {
    var container = document.getElementById('spn-container');
    if (!container) return;

    var productName = container.getAttribute('data-product') || 'este producto';

    var nombres = ['Carlos', 'Luis', 'Maria', 'Fernanda', 'Jorge', 'Andres', 'Gabriela', 'Carmen', 'Jose', 'Daniela'];
    var apellidos = ['Zambrano', 'Sanchez', 'Vera', 'Torres', 'Lopez', 'Garcia', 'Mendoza', 'Castro', 'Cedeno', 'Romero'];

    function randomItem(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
    }

    function initials(nombre, apellido) {
    return (nombre.charAt(0) + apellido.charAt(0)).toUpperCase();
    }

    function buildMessage() {
    var esReciente = Math.random() < 0.5;
    if (esReciente) {
    return 'acaba de comprar <strong>' + productName + '</strong>.';
    }
    var minutos = Math.floor(Math.random() * 58) + 2;
    return 'compro <strong>' + productName + '</strong> hace ' + minutos + ' minutos.';
    }

    var hideTimer = null;
    var nextTimer = null;

    function scheduleNext() {
    var pausa = 7000 + Math.floor(Math.random() * 3000);
    nextTimer = setTimeout(showNotification, pausa);
    }

    function showNotification() {
    var nombre = randomItem(nombres);
    var apellido = randomItem(apellidos);
    var mensaje = buildMessage();

    var popup = document.createElement('div');
    popup.className = 'spn-popup';
    popup.innerHTML =
    '<div class="spn-avatar">' + initials(nombre, apellido) + '</div>' +
    '<div class="spn-body">' +
    '<p class="spn-name">' + nombre + ' ' + apellido + '</p>' +
    '<p class="spn-text">' + mensaje + '</p>' +
    '</div>' +
    '<button type="button" class="spn-close" aria-label="Cerrar">&times;</button>';

    container.innerHTML = '';
    container.appendChild(popup);

    var closeBtn = popup.querySelector('.spn-close');
    closeBtn.addEventListener('click', function () {
    clearTimeout(hideTimer);
    popup.classList.remove('spn-show');
    scheduleNext();
    });

    requestAnimationFrame(function () {
    popup.classList.add('spn-show');
    });

    hideTimer = setTimeout(function () {
    popup.classList.remove('spn-show');
    scheduleNext();
    }, 5000);
    }

    function init() {
    setTimeout(showNotification, 4000);
    }

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    } else {
    init();
    }
    })();